<div class="file-viewer">
	<div class="file-list" *ngIf="files.length > 1">
		<button *ngFor="let file of files" (click)="selectFile(file)" [class.has-notification]="file.hasEvidence"
			[class.selected]="selectedFile?.id === file.id" class="nav-button text-button">
			{{ file.name }}
		</button>
	</div>

	<div class="file-viewer-container">
		<div class="file-content" *ngIf="selectedFile">
			<div class="content-display" [ngSwitch]="selectedFile.type">
				<div *ngSwitchCase="'text/html'" class="text-content">
					<app-annotated-text *ngIf="selectedFile.annotatedText !== undefined; else noTextProvided"
						[selectedFactors]="activeAspectIds"
						[annotatedText]="selectedFile.annotatedText"></app-annotated-text>
					<ng-template #noTextProvided>
						No text has been provided for this document.
					</ng-template>

				</div>

				<div *ngSwitchDefault class="unsupported-format">
					Unsupported file format. Please download to view.
					<a [href]="selectedFile.url" download>Download {{ selectedFile.name }}</a>
				</div>
			</div>
		</div>

		<div class="no-file-selected" *ngIf="!selectedFile">Select a file to view its contents</div>
	</div>
</div>